import { useTranslation } from "react-i18next";
import { Claim } from "@/types";
import DrawerTabs, { DrawerTab } from "@/components/atoms/DrawerTabs";
import Text from "@/components/atoms/Text";
import Group from "@/components/atoms/Group";
import Drawer from "@/components/molecules/Drawer";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import DetailsTab from "./TabsContent/DetailsTab";

interface ClaimsAdminDrawerProps {
  claim: Claim | null;
  onClose: () => void;
  isOpen: boolean;
}

const ClaimsAdminDrawer = ({ onClose, isOpen, claim }: ClaimsAdminDrawerProps) => {
  const { t } = useTranslation();
  return (
    <Drawer onClose={onClose} isOpen={isOpen} title={<DrawerHeader />}>
      <DrawerTabs defaultValue={"details"}>
        <DrawerTabs.List>
          <DrawerTabs.Tab value="details">
            <DrawerTab svgName="list" label={t("common:details")} />
          </DrawerTabs.Tab>
        </DrawerTabs.List>

        <DrawerTabs.Panel value="details">
          <DetailsTab claim={claim} onClose={onClose} />
        </DrawerTabs.Panel>
      </DrawerTabs>
    </Drawer>
  );
};

export default ClaimsAdminDrawer;

const DrawerHeader = () => {
  const { t } = useTranslation();
  return (
    <Group gap="20px" align="center">
      <SVGAsset name="warning-triangle" />
      <Text size="md" display="technical" tt="uppercase" strong={true}>
        {t("claims:claim")}
      </Text>
    </Group>
  );
};
